import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class ModelHasAsset extends BaseEntityModel {
  assetId?: number;
  shareOfOwnership: number;

  constructor(model: Partial<ModelHasAsset> = {}) {
    super(model);

    this.assetId = model.assetId;
    this.shareOfOwnership = model.shareOfOwnership as number;
  }

  get formattedShareOfOwnership(): number {
    return this.shareOfOwnership ?? 0;
  }

  set formattedShareOfOwnership(newValue: number) {
    this.shareOfOwnership = Math.round(newValue * 100) / 100;
  }

  get shareIsValid(): boolean {
    return this.shareOfOwnership >= 0 && this.shareOfOwnership <= 100;
  }

  clone(): ModelHasAsset {
    return ModelHasAsset.mapModel(this);
  }
}
